import { render, staticRenderFns } from "./AdminMainPanel.vue?vue&type=template&id=5ba84467&"
import script from "./AdminMainPanel.vue?vue&type=script&lang=js&"
export * from "./AdminMainPanel.vue?vue&type=script&lang=js&"
import style0 from "./AdminMainPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports